import { ReactNode } from "react";

interface Props {
  children: ReactNode;
  onClick?: () => void | Promise<void>;
  isActive?: boolean;
}

/**
 * ページング用のボタン
 */
export default function PageButton({ isActive, children, onClick }: Props) {
  const bg = isActive ? "pointer-events-none" : "hover:bg-green-primary-100";
  const textSize = "text-color-green-100 text-base font-bold leading-normal";
  const disabledClass =
    "disabled:text-green-primary-600 disabled:border-green-primary-600 disabled:bg-green-primary-100";
  return (
    <button
      className={`${bg} ${textSize} ${disabledClass} flex items-center justify-center h-10 md:h-9 min-w-[40px] md:min-w-[36px] px-2 rounded border border-transparent`}
      onClick={onClick}
      disabled={isActive}
    >
      {children}
    </button>
  );
}
